const { isSameUTCDay } = require('../utils/dateAndTime');

const INITIAL_STATE = {
  items: [],
  coinBonus: 0,
  diamondBonus: 0,
  fetchingInProgressSince: null,
  lastSuccessfulFetch: null,
  lastFailedFetch: null,
  lastErrorMessage: null,
};

module.exports = function DailyQuestsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'FETCH_QUESTS_PROGRESS_IN_PROGRESS':
      return {
        ...state,
        fetchingInProgressSince: action.timestamp,
      };
    case 'FETCH_QUESTS_PROGRESS_SUCCESSFUL': {
      const changedProgresses = action.progres.filter((newProgress) => {
        const oldProgress = state.items.find(
          (oldProgres) => oldProgres.placement === newProgress.placement,
        );
        return (
          isSameUTCDay(newProgress.lastWatchedAt, new Date()) &&
          ((!oldProgress && state.lastSuccessfulFetch) ||
            (oldProgress &&
              oldProgress.lastWatchedAt &&
              isSameUTCDay(
                oldProgress.lastWatchedAt,
                newProgress.lastWatchedAt,
              ) &&
              newProgress.rewardsClaimed !== oldProgress.rewardsClaimed))
        );
      });

      const questsCompleted = changedProgresses.map((progress) =>
        action.quests.find((quest) => quest._id === progress.placement),
      );

      return {
        ...state,
        fetchingInProgressSince: null,
        items: action.progres,
        coinBonus: questsCompleted
          .filter((quest) => quest.adRewardType === 'lootcoin')
          .reduce((a, b) => a + b.adRewardAmount, 0),
        diamondBonus: questsCompleted
          .filter((quest) => quest.adRewardType === 'diamond')
          .reduce((a, b) => a + b.adRewardAmount, 0),
        lastSuccessfulFetch: action.timestamp,
      };
    }
    case 'FETCH_QUESTS_PROGRESS_FAILED':
      return {
        ...state,
        fetchingInProgressSince: null,
        lastFailedFetch: action.timestamp,
        lastErrorMessage: action.reason,
      };
    case 'LOGOUT_SUCCESSFUL':
      return {
        ...INITIAL_STATE,
      };
    case 'SET_LANGUAGE':
    case 'LOGIN_SUCCESSFUL':
      return {
        ...state,
        fetchingInProgressSince: null,
        lastSuccessfulFetch: null,
      };
    default:
      return state;
  }
};
